import dayjs from 'dayjs'
import { Direction, Pricing, RailTransport } from '../../../bewotec/openapi'
import { DEFAULT_DATE_FORMAT } from '../../../general/helper'
import { IPaxConfig } from '../../../store/catalog/interfaces'
import { IDetailRoute } from '../cruise/interfaces'
import { IError, IFetchRailOption, IFetchRailOptionByDirection, RailDirection, RailLabel } from './interfaces'

export const convertToExpitecDirection = (direction: string): Direction => {
  switch (direction) {
    case 'both': {
      return Direction.RT
    }
    case 'inbound': {
      return Direction.R
    }
    case 'outbound': {
      return Direction.O
    }
    default:
      return Direction.RT
  }
}

export const getRailLabel = (direction: string): RailLabel => {
  switch (direction) {
    case 'both':
      return 'Hin- und Rückfahrt'
    case 'outbound':
      return 'Hinfahrt'
    case 'inbound':
      return 'Rückfahrt'
    default:
      return ''
  }
}

export const getRailTariff = (railTariff: string): string => {
  switch (railTariff) {
    case 'FLEX':
      return 'Flexpreis'
    case 'SPAR':
      return 'Sparpreis'
    case 'RFLF':
    case 'RFLY':
    case 'RFCO':
      return 'Rail&Fly'
    default:
      return railTariff
  }
}

export const calculateRailPricing = (pricings: Pricing[]) => {
  if (!pricings.length) return 0

  let total = 0

  pricings.forEach(pricing => {
    total += pricing.amount ?? 0
  })

  return total
}

export const getDummyPaxAges = (paxConfig: IPaxConfig, childrenOlderThanFourteen?: number, birthdates?: string[]) => {
  const paxAges: number[] = []

  for (let i = 0; i < paxConfig.adults; ++i) {
    paxAges.push(40)
  }

  for (let j = 0; j < paxConfig.juveniles; ++j) {
    paxAges.push(18)
  }

  for (let k = 0; k < paxConfig.children; ++k) {
    if (!!birthdates?.length && k < Object.values(birthdates).length) {
      const formattedBirthdate = dayjs(Object.values(birthdates)[k], DEFAULT_DATE_FORMAT)

      paxAges.push(dayjs().diff(formattedBirthdate, 'year'))
    } else if (!!childrenOlderThanFourteen && k < childrenOlderThanFourteen) {
      paxAges.push(15)
    } else {
      paxAges.push(8)
    }
  }

  for (let l = 0; l < paxConfig.babies; ++l) {
    paxAges.push(1)
  }

  return paxAges
}

export const mapRailOption = (option: RailTransport): IFetchRailOption => {
  return {
    id: option.code,
    railClassCode: option.railClassCode,
    railClassName: option.railClassName,
    railTarifCode: option.railTariffCode,
    railTarifName: option.railTariffName,
    price: calculateRailPricing(option.pricings),
    available: true,
    type: option.type,
  }
}

export const mapRailErrorText = (
  route: IDetailRoute | null,
  availableRailOptions: IFetchRailOptionByDirection | IError,
  direction: RailDirection
) => {
  const isRailAvailable: boolean =
    !('error' in availableRailOptions) &&
    (!!availableRailOptions?.[Direction.RT]?.length ||
      !!availableRailOptions?.[Direction.R]?.length ||
      !!availableRailOptions?.[Direction.O]?.length)
  const hasGermanDeparture: boolean = !!route?.germanDeparture
  const hasGermanArrival: boolean = !!route?.germanArrival
  const needsGermanDeparture = ['both', 'outbound'].includes(direction)
  const needsGermanArrival = ['both', 'inbound'].includes(direction)

  if (!isRailAvailable) {
    return 'Lade Bahnoptionen...'
  }
  if (needsGermanDeparture && !hasGermanDeparture) {
    return 'Reise beginnt nicht in Deutschland.'
  }
  if (needsGermanArrival && !hasGermanArrival) {
    return 'Reise endet nicht in Deutschland.'
  }

  return ''
}

export const railHelper = {
  mapRailOption,
}
